export default __webpack_public_path__ + "static/media/Xray.c85b987f.png";